import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import ModalComponent from '@components/modal/Modal.component';
import { Button, Stack } from '@mui/material';
import TextFieldComponent from '@components/inputs/textField/TextField.component';

interface ManagePriceCatalogProps {
  isCreation?: boolean;
}

const ManagePriceCatalog = (props: ManagePriceCatalogProps) => {
  const {isCreation} = props;

  const {t} = useTranslation();
  const navigate = useNavigate();

  const handleClose = () => navigate('..', {replace: true});

  return (
    <ModalComponent
      title={t(`settings.priceCatalog.manage.title.${isCreation ? 'add' : 'edit'}`)}
      handleClose={handleClose}
      content={(
        <Stack width="70%" spacing={2} pt="55px" pb="8px">
          <TextFieldComponent
            color="secondary"
            labelWidth={200}
            label={'*' + t('settings.priceCatalog.manage.name')}/>
          <TextFieldComponent
            color="secondary"
            labelWidth={200}
            label={t('settings.priceCatalog.manage.organisations')}/>
        </Stack>
      )}
      actions={(
        <Button variant="contained" color="primary">
          {t('global.save')}
        </Button>
      )}/>
  );
};

export default ManagePriceCatalog;
